module.exports = {
      id: "photo-usage",
      viewBox: "0 0 12 9",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#photo",
      toString: function () {
        return this.url;
      }
    }